module.exports = __webpack_public_path__ + "static/media/matbasica1.e4918d0c.png";